var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.isLoading)?_c('div',{class:_vm.classes},[_c('div',{staticClass:"lds-circle"},[_c('small',[_vm._v(_vm._s(_vm.options.text))]),_vm._v(" "),_c('div',{class:`loader-${_vm.options.class}`})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }